import React, { useCallback, useEffect, useState } from "react";
// helper
import { useLocation, useNavigate } from "react-router";
import { PubSub } from "../../helper/pubSub";
import { useAccordion } from "../../contexts/AccordionContext";
// icons
import HospitalLogo from "../../img/user/hospital.png";
import PatientLogo from "../../img/user/patient.png";
import { IoMdInformationCircle } from "react-icons/io";
import BasicSidebar from "./BasicSidebar";

interface SidebarClinicianState {
  information: boolean;
}

const SidebarClinician = () => {
  const { state: appState, handleAccordion, closeAll } = useAccordion();
  const location = useLocation();
  const navigate = useNavigate();

  const informationPaths = [
    "/clinician/information",
    "/impressum",
    "/privacypolicy",
    "/contact",
  ]; //all paths belonging to information section. For these paths the menu stays open

  const [display, setDisplay] = useState<SidebarClinicianState>({
    information: informationPaths.includes(location.pathname),
  });

  //get accordion state from context
  const isPatientsOpen = appState.clinician.myPatients !== "-1";
  const isClinicOpen = appState.clinician.clinics !== "-1";

  const closeAllAccordions = useCallback(() => {
    console.log("Called closeAllAccordions");
    setDisplay({ information: false });
    closeAll("clinician");
  }, [closeAll]);

  /**
   * State Handlers
   * Navigates to clinician page if not already there
   * toggles the accordion with handleAccordion
   * Closes the information state
   */
  const handlePatientItem = () => {
    const newUrl = "/clinician";

    if (location.pathname !== newUrl) {
      navigate(newUrl);
      setTimeout(() => {
        handleAccordion({ input: "myPatients", userType: "clinician" });
      }, 100);
    } else {
      handleAccordion({ input: "myPatients", userType: "clinician" });
    }
    setDisplay({ information: false });
  };

  const handleClinicItem = () => {
    if (location.pathname !== "/clinician") {
      navigate("/clinician");
      setTimeout(() => {
        handleAccordion({ input: "clinics", userType: "clinician" });
      }, 100);
    } else {
      handleAccordion({ input: "clinics", userType: "clinician" });
    }
    setDisplay({ information: false });
  };

  const handleInfoItem = () => {
    setDisplay((prevState) => ({ information: !prevState.information }));
    closeAll("clinician");
    if (location.pathname !== "/clinician/information") {
      navigate("/clinician/information");
    }
  };

  /**
   * Subscribes to the 'close-sidebar-submenus' PubSub event
   * Cleans up the subscription on unmount
   * Removes the former localStorage management
   */
  useEffect(() => {
    const subscription = PubSub.getInstance().subscribeToTopic(
      "close-sidebar-submenus",
      closeAllAccordions,
    );

    return () => {
      // clear subscription
      PubSub.getInstance().unsubscribe(subscription);
    };
  }, [closeAllAccordions]);

  const patientSidebarItem = {
    title: "Patient*innen",
    activeButton: isPatientsOpen,
    onClickFunction: handlePatientItem,
    imgSrc: PatientLogo,
  };

  const clinicSidebarItem = {
    title: "Klinik",
    activeButton: isClinicOpen,
    onClickFunction: handleClinicItem,
    imgSrc: HospitalLogo,
  };

  const informationSidebarItem = {
    title: "Informationen",
    activeButton: display.information,
    onClickFunction: handleInfoItem,
    imgSrc: <IoMdInformationCircle size={25} />,
    buttonId: "clinic-stuff-sidebar-information",
    ariaExpand: display.information,
    ariaControl: "documentation",
    hiddenOnMobile: true,
    subMenu: [
      {
        title: "Impressum",
        redirectLink: "/impressum",
      },
      {
        title: "Datenschutz",
        redirectLink: "/privacypolicy",
      },
      {
        title: "Kontakt",
        redirectLink: "/contact",
      },
    ],
  };

  return (
    <BasicSidebar
      sidebarItems={[
        patientSidebarItem,
        clinicSidebarItem,
        "---",
        informationSidebarItem,
      ]}
    />
  );
};

export default SidebarClinician;
